

































































































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { getVIPInfoList } from '@/api/trade/trade-android'
import { exportJson2Excel } from '@/utils/excel'
import {
  formatJson,
  resetObjValue2NoneString,
  checkNoneString
} from '@/utils/tool'
import { Form } from 'element-ui'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'

const goodsTypeList = [
  {
    'id': 1,
    'name': '永久'
  },
  {
    'id': 0,
    'name': '其他'
  }
]

@Component({
  name: 'TradeVip'
})
export default class extends mixins(DateOption) {
  // api data
  private params = {
    user_id: '',
    createDateStart: '',
    createDateEnd: '',
    vipExpireDateStart: '',
    vipExpireDateEnd: '',
    page: 1,
    pageCount: 20
  }
  private formParams = {
    udid: '',
    goodsType: '',
    days: 0
  }
  udidParams = {
    id: 0,
    udid: '',
    newUdid: ''
  }
  // component data
  goodsTypeList = goodsTypeList
  visible = false
  dateArrayCreate = ['', '']
  dateArrayExpire = ['', '']
  tableLoading = false
  tableData: any[] = []
  selectedData: any[] = []
  totalCount = 0
  formVisible = false
  rules: any = {
    udid: [{ required: true, message: '请填写UDID', trigger: 'blur' }],
    goodsType: [{ required: true, message: '请选择类别', trigger: 'change' }]
  }
  // lifecycle
  async created() {
    this.getTableData()
    // this.getAccountStatus()
    // this.getAreaList()
  }
  // methods
  async getTableData() {
    this.tableLoading = true
    let res: any = await getVIPInfoList(this.params)
    this.tableData = res.data.dataList
    this.totalCount = res.data.pageInfo.totalCount
    this.tableLoading = false
  }
  changeCreateDate(date: string[]) {
    this.params.createDateStart = date && date[0]
    this.params.createDateEnd = date && date[1]
  }
  changeExpireDate(date: string[]) {
    this.params.vipExpireDateStart = date && date[0]
    this.params.vipExpireDateEnd = date && date[1]
  }
  transDevice(item: any) {
    this.udidParams.id = parseInt(item.id)
    this.udidParams.udid = item.udid
    this.visible = true
  }
  // async handleRemove(item: any) {
  //   console.log(item)
  //   let res: any = await removeBlackList({ token: '3def8159cee7e5b4d4e47ad081b4641a', udid: item.udid })
  //   if (~~res.status.code === 0) this['$message'].success('操作成功')
  //   if (~~res.status.code === -1) this['$message'].warning(res.data)
  // }
  async handleExcel() {
    // let res: any = await getAccountList({
    //   page: 1,
    //   pageCount: 3000
    // })
    // if (res.status.code === 0) {
    //   setTimeout(() => {
    //     this['$message'].success('导出成功!')
    //   }, 200)
    // } else {
    //   this['$message'].error('导出失败!')
    //   return
    // }
    // const filterVal: string[] = [
    //   'id',
    //   'accountId',
    //   'certName',
    //   'applePwd',
    //   'iphoneCount',
    //   'itouchCount',
    //   'status',
    //   'info',
    //   'createDate',
    //   'creatorName'
    // ]
    // const theader: string[] = [
    //   'ID',
    //   '开发者账号',
    //   '证书',
    //   '专用密码',
    //   'iPhone可安装数量',
    //   'iPad可安装数量',
    //   '状态',
    //   '信息',
    //   '创建时间',
    //   '创建人'
    // ]
    // const list = res.data.dataList
    // const data = formatJson(filterVal, list)
    // exportJson2Excel(theader, data)
  }

  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.dateArrayExpire = ['', '']
    this.dateArrayCreate = ['', '']
    this.params.page = 1
    this.getTableData()
  }
  handleAdd() {
    this.formVisible = true
  }
  handleSelectionChange(list: any[]) {
    console.log(list)
    this.selectedData = list
  }
  // async confirmTransfer() {
  //   if (this.udidParams.udid === this.udidParams.newUdid) return this['$message'].error('新旧UDID不能相同!')
  //   let res: any = await changeUdid(this.udidParams)
  //   if (~~res.status.code === 0) this['$message'].success('操作成功')
  //   else this['$message'].warning(res.status.message)
  //   this.handleFormClose()
  //   await this.getTableData()
  // }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.id)
    tempSelectList = this.selectedData.map(item => item.id)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.id)) this.selectedData.push(item)
    })
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleUpdateAll() {
    // this.setAccount(this.selectIds)
  }
  handleRefund(item: any) {
    console.log(item)
    this.$confirm('是否确认要退款?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        // let uid = ''
        // uid = item.uid
        // let res: any = await deleteAccount({ uid })
        // if (res.status.code === 0) {
        //   this['$message'].success('删除成功!')
        //   setTimeout(() => {
        //     this.getTableData()
        //   }, 1500)
        // } else {
        //   this['$message'].error('删除失败!')
        // }
      })
      .catch(() => {})
  }
  // close dialog, clear data
  handleFormClose() {
    this.udidParams = {
      id: 0,
      udid: '',
      newUdid: ''
    }
    this.visible = false
  }

  closeForm() {
    (this.$refs['formParams'] as Form).resetFields()
    this.formVisible = false
  }

  cancelForm() {
    this.formVisible = false
  }
  // confirmForm() {
  //   (this.$refs['formParams'] as Form).validate(valid => {
  //     if (valid) {
  //       let { udid, days, goodsType } = this.formParams
  //       let isPermanent: boolean = Boolean(goodsType)
  //       if (days <= 0 && !isPermanent) return this['$message'].warning('请填写完成后再提交!')
  //       addVIP({ udid, days, isPermanent })
  //         .then(async(res: any) => {
  //           if (~~res.status.code === 0) {
  //             this['$message'].success('操作成功')
  //             this.closeForm()
  //             await this.getTableData()
  //           } else {
  //             this['$message'].warning(res.status.message)
  //           }
  //         })
  //         .catch(err => err)
  //     } else {
  //       return this['$message'].warning('请填写完成后再提交!')
  //     }
  //   })
  // }
  // computed
  get selectCount() {
    return this.selectedData.length
  }
  get selectIds() {
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    let ids = t.join(',')
    return ids
  }
}
